/* HARLUX PDP */
(function(){
  var root=document.querySelector('.hp-r[data-hp-root]');
  if(!root)return;
  var atcLabel=root.getAttribute('data-hp-atc-label');

  // GALLERY
  var slides=root.querySelector('[data-hp-slides]');
  var dots=[].slice.call(root.querySelectorAll('[data-hp-dots] .hp-dot'));
  var thumbs=[].slice.call(root.querySelectorAll('[data-hp-thumbs] .hp-thumb'));
  function goto(i){ if(!slides)return; var w=slides.clientWidth; slides.scrollTo({left:w*i,behavior:'smooth'}); }
  function mark(i){ dots.forEach(function(d,x){d.classList.toggle('on',x===i);}); thumbs.forEach(function(t,x){t.classList.toggle('on',x===i);}); }
  dots.concat(thumbs).forEach(function(el){ el.addEventListener('click',function(){ var i=+el.getAttribute('data-hp-i'); goto(i); mark(i); }); });
  if(slides){ slides.addEventListener('scroll',function(){ var i=Math.round(slides.scrollLeft/slides.clientWidth); mark(i); }); }

  // VARIANTS
  var pills=[].slice.call(root.querySelectorAll('[data-hp-opt] .hp-pill'));
  var priceEl=root.querySelector('[data-hp-price]');
  var compareEl=root.querySelector('[data-hp-compare]');
  var atc=root.querySelector('[data-hp-atc]');
  var atcTxt=root.querySelector('[data-hp-atc-txt]');
  var stockEl=root.querySelector('[data-hp-stock]');
  var stockTxt=root.querySelector('[data-hp-stock-txt]');
  var current=+root.getAttribute('data-hp-current');
  var lowThreshold=+root.getAttribute('data-hp-low');
  var saveEl=root.querySelector('[data-hp-save]');
  var atcPrice=root.querySelector('[data-hp-atc-price]');
  function applyAccent(hex){ if(hex) root.style.setProperty('--accent',hex); }
  function applySave(txt){ if(!saveEl)return; if(txt){ saveEl.textContent=txt; saveEl.hidden=false; } else { saveEl.hidden=true; } }
  function applyAtcPrice(p){ if(atcPrice) atcPrice.textContent = p ? (' · '+p) : ''; }
  var mediaMap={}; [].slice.call(root.querySelectorAll('.hp-slide')).forEach(function(s,i){ var mid=s.getAttribute('data-hp-mid'); if(mid) mediaMap[mid]=i; });

  function refreshStock(tracked,inv,avail){
    if(!stockEl)return;
    if(tracked==='1' && avail==='true' && inv!=='' && (+inv)>0 && (+inv)<=lowThreshold){
      stockTxt.textContent='Only '+inv+' left';
      stockEl.hidden=false;
    } else { stockEl.hidden=true; }
  }
  function selectVariant(btn){
    current=+btn.getAttribute('data-hp-variant');
    pills.forEach(function(p){p.classList.toggle('on',p===btn);});
    if(priceEl) priceEl.textContent=btn.getAttribute('data-hp-vprice');
    var vc=btn.getAttribute('data-hp-vcompare');
    if(compareEl){ if(vc){compareEl.textContent=vc;compareEl.style.display='';}else{compareEl.style.display='none';} }
    var avail=btn.getAttribute('data-hp-vavail');
    if(atc){ if(avail==='true'){ atc.disabled=false; atcTxt.textContent=atcLabel; } else { atc.disabled=true; atcTxt.textContent='Sold out'; } }
    refreshStock(btn.getAttribute('data-hp-vtracked'),btn.getAttribute('data-hp-vinv'),avail);
    applyAccent(btn.getAttribute('data-hp-vaccent'));
    applySave(btn.getAttribute('data-hp-vsave'));
    applyAtcPrice(btn.getAttribute('data-hp-vprice'));
    var mid=btn.getAttribute('data-hp-vmid'); if(mid && mediaMap[mid]!=null){ goto(mediaMap[mid]); mark(mediaMap[mid]); }
    harluxAtcReset();
  }
  pills.forEach(function(p){ p.addEventListener('click',function(){ if(p.classList.contains('out'))return; selectVariant(p); }); });
  // init for first/current variant
  (function(){
    var on=root.querySelector('.hp-pill.on');
    if(on){
      refreshStock(on.getAttribute('data-hp-vtracked'),on.getAttribute('data-hp-vinv'),on.getAttribute('data-hp-vavail'));
      applyAccent(on.getAttribute('data-hp-vaccent'));
      applySave(on.getAttribute('data-hp-vsave'));
      applyAtcPrice(on.getAttribute('data-hp-vprice'));
    } else {
      applyAccent(root.getAttribute('data-hp-caccent'));
      applySave(root.getAttribute('data-hp-csave'));
      applyAtcPrice(root.getAttribute('data-hp-cprice'));
    }
  })();

  // DISPATCH COUNTDOWN
  var cutoffEl=root.querySelector('[data-hp-cutoff]');
  var cutoffHour=+root.getAttribute('data-hp-cutoff-hour');
  var cutoffMsg=root.getAttribute('data-hp-cutoff-msg');
  if(cutoffEl){
    setInterval(function(){
      var now=new Date(); var end=new Date(); end.setHours(cutoffHour,0,0,0);
      if(now>=end){ cutoffEl.textContent=cutoffMsg; return; }
      var diff=Math.floor((end-now)/1000); var h=Math.floor(diff/3600), m=Math.floor((diff%3600)/60), s=diff%60;
      cutoffEl.textContent='Order within '+h+'h '+m+'m '+s+'s for dispatch today';
    },1000);
  }

  // UPSELL
  var upsellWrap=root.querySelector('[data-hp-upsell]');
  var upsellToggle=root.querySelector('[data-hp-upsell-toggle]');

  // ATC (locked flow)
  function harluxAtcReset(){ if(atc && !atc.classList.contains('_sold')){ var on=root.querySelector('.hp-pill.on'); if(!on||on.getAttribute('data-hp-vavail')==='true'){ atc.disabled=false; } } }
  window.addEventListener('pageshow',function(e){ harluxAtcReset(); });
  if(atc){
    atc.addEventListener('click',function(){
      if(atc.disabled)return;
      atc.disabled=true; atcTxt.textContent='Adding…'; if(atcPrice) atcPrice.textContent='';
      var items=[{id:current,quantity:1}];
      if(upsellWrap && upsellToggle && upsellToggle.checked){ items.push({id:+upsellWrap.getAttribute('data-hp-upv'),quantity:1}); }
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){ return r.json(); })
        .then(function(){ window.location.href='/cart'; })
        .catch(function(){ atc.disabled=false; atcTxt.textContent=atcLabel; });
    });
  }
})();
